/**
 * Ceci est un copier/coller du src/core/models/step.model.ts du projet iackathon
 */
import {CANVAS_BLOC_ID} from './canvas-block-id';

export enum TESTER_LEVEL_APPRECIATION {
  NotSet = 'not_set',
  NotAgree = 'not_agree',
  MostlyAgree = 'mostly_agree',
  TotallyAgree = 'totally_agree',
}

export interface IackathonSaveState {
  author_name: string;
  group_name: string;
  members: Member[];
  current_step_id?: string;
  max_step_reach: string;
  header: Header;
  is_countdown_active?: boolean;
  global_countdown_limit_date?: number;
  framing_step: FramingStep;
  sdg_theme_step: SdgThemeStep;
  problem_step: ProblemStep;
  solution_step: SolutionStep;
  ai_log_missions: AiLogMission[];
  odd_canvas_step: { [key in CANVAS_BLOC_ID]?: string };
  dashboard: DashboardConfig;
  deliverable: IackathonDeliverable;
  groups_project_reviews: GroupsProjectReviews;
}

export type IackathonDeliverableModerationStatus = 'pending' | 'approved' | 'rejected';

export interface IackathonDeliverable {
  format: string;
  countdown_limit_date: number | null;
  url: string;
  is_external: boolean;
  filename: string;
}

interface GroupsProjectReviews {
  [groupId: string]: {
    ingenuity: number | null;
    feasibility: number | null;
    would_you_use_it?: number | null;
    comments: string;
    long_time_impact: number | null;
    how_make_it_another_way: string;
    special_mark: number | null;
  };
}

export const SPECIAL_MARK_OPTIONS = [
  {value: 0, pseudoIcon: 'brain', label: 'Hyper ingénieux\u00A0!'},
  {value: 1, pseudoIcon: 'rocket', label: 'C’est le futur\u00A0!'},
  {value: 2, pseudoIcon: 'check', label: 'On en a vraiment besoin\u00A0!'},
  {value: 3, pseudoIcon: 'clapping_hands', label: 'Présentation géniale\u00A0!'},
  {value: 4, pseudoIcon: 'palette', label: 'Idée très originale\u00A0!'},
] as const;

export interface DashboardConfig {
  matrix_slot: { locked: boolean; complete: boolean };
  final_idea: { locked: boolean; complete: boolean };
  canvas: { locked: boolean; complete: boolean };
  deliverable: { locked: boolean; complete: boolean };
}

export interface Member {
  id: number;
  name: string;
  color_identifier: string;
  role: unknown | undefined;
}

export enum IdeaCategory {
  ConventionalImpossible = 'conventional_impossible',
  OriginalImpossible = 'original_impossible',
  ConventionalPossible = 'conventional_possible',
  OriginalPossible = 'original_possible',
}

export interface SortedIdea {
  idea: string;
  category: IdeaCategory;
}

export interface SolutionStep {
  countdown_limit_date: number | null;
  ideas: string[];
  how_wow_sub_step: number;
  sorted_ideas?: SortedIdea[];
  chosen_idea?: SortedIdea;
}

export interface ProblemStep {
  countdown_limit_date: number | null;
  problematic: string;
}

export enum SplitState {
  INIT = 'init',
  TOP = 'split-top-highlight',
  BOTTOM = 'split-bottom-highlight',
}

export interface SdgThemeStep {
  chosen_theme: string;
  top_members: Member[];
  top_group_answers: {
    first_number: string;
    second_number: string;
    third_number: string;
  };
  bottom_group_answers: {
    what: string;
    why: string;
  };
  bottom_members: Member[];
  countdown_limit_date: number | null;
  split_state?: SplitState;
}

export interface Header {
  is_role_helper_allowed: boolean;
  is_tools_helper_allowed: boolean;
  is_ia_log_helper_allowed: boolean;
  is_odd_dashboard_allowed: boolean;
}

export interface AiLogMission {
  id: number;
  why: string;
  iaToolsWhich: {
    description: string;
    isPredefined: boolean;
  };
  prompt: {
    value: string;
    score: {
      context: null | 0 | 1 | 2;
      goals: null | 0 | 1 | 2;
      format: null | 0 | 1 | 2;
    };
  };
  review: {
    advice: string;
    score: {
      relevance: null | 0 | 1 | 2;
      effective: null | 0 | 1 | 2;
      format: null | 0 | 1 | 2;
    };
  };
  usefulness: null | 0 | 1 | 2;
  createdAt: string;
}

export interface FramingStep {
  odd: {
    members: Member[];
    what: string;
    why: string;
  };
  even: {
    members: Member[];
    what: string;
    why: string;
  };
  countdown_limit_date: number | null;
  is_tester_agree: TESTER_LEVEL_APPRECIATION;
  active_group_split?: 'odd' | 'even';
  active_group_answers?: 'odd' | 'even';
}

export interface StepConfig {
  id: string;
  description: string;
  component:string;
  isAside?: boolean;
  breadcrumbsItem: string;
}
